import { combineReducers, compose, createStore, applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';
import { UserReducer } from './users';
import { ActivityReducer } from './activity';
import { GuestReducer } from './guest';
import { NotifReducer } from './notifs';

export const ConfigureStore = () => {
    const store = createStore(combineReducers({ users: UserReducer , activity: ActivityReducer , guests:GuestReducer , notifs : NotifReducer }), 
    compose(applyMiddleware(thunk)));
    return store;
}